module.exports = __webpack_public_path__ + "static/media/wellness-offer.5807fab7.svg";